(function () {
    'use strict';

    angular
        .module('app')
        .controller('EmailAddressAuditListCtrl', EmailAddressAuditListCtrl);

    /**
     * @ngdoc controller
     * @name EmailAddressAuditListCtrl
     *
     * @description
     * List screen for Email Addresses Audits
     */

    EmailAddressAuditListCtrl.$inject = [
        '$q',
        '$routeParams',
        'SystemService',
        'EmailAddressService',
        'DialogService',
        'NavigationAidService',
        'ChilliUserProfileService',
        'WindowTitleService'];

    function EmailAddressAuditListCtrl(
        $q,
        $routeParams,
        SystemService,
        EmailAddressService,
        DialogService,
        NavigationAidService,
        ChilliUserProfileService,
        WindowTitleService) {

        var vm = this;
        var emailAddressId = null;
        vm.emailAddressAuditCount = 0;
        vm.currentPage = 1;
        vm.loadingGrid = true;
        vm.loading = true;
        vm.permissionDenied = false;
        vm.notFound = false;
        vm.error = null;
        vm.toggleAuditDetails = toggleAuditDetails;
        vm.formatAuditType = formatAuditType;
        vm.close = close;
        vm.updateList = updateList;
        Object.defineProperty(vm, 'titleText', { get: function () { if (_.isNil(vm.emailAddress)) { return 'Email Address History'; } else { return 'Email Address History - ' + vm.emailAddress.Address; } } });

        activate();

        function activate() {
            WindowTitleService.setTitle(vm.titleText);

            ChilliUserProfileService.verifyUserIsAdministrator({
                onUserIsAdmin: loadEverything,
                onUserIsNotAdmin: function () { vm.permissionDenied = true; },
                onError: function (response) { DialogService.error('Error loading User profile', response); },
                onFinally: function () {
                    vm.loading = false;
                    WindowTitleService.setTitle(vm.titleText);
                }
            });
        }

        /**
         * Initialises the email address audit list.
         * A watch is set on the currentPage variable, when this is changed the list will be updated.
         */
        function loadEverything() {
            emailAddressId = $routeParams.id;

            var loadPromises = [];

            var getPageSizePromise = SystemService.getMenuListSize('Email Address Audits')
                .then(getListPageSizeOk);

            var getEmailAddress = EmailAddressService.get(emailAddressId)
                .then(getEmailAddressOk, getEmailAddressError);

            loadPromises.push(getPageSizePromise);
            loadPromises.push(getEmailAddress);

            return $q.all(loadPromises)
                .then(function () {
                    updateList();
                }, function (response) {
                    vm.error = response;
                    vm.loadingGrid = false;
                });


            function getListPageSizeOk(data) {
                vm.listPageSize = data;
            }

            function getEmailAddressOk(data) {
                vm.emailAddress = data;
            }

            function getEmailAddressError(response) {
                if (response.status === 404) {
                    vm.notFound = true;
                }

                return $q.reject(response);
            }
        }

        /**
         * Refreshes the email address audit list.
         */
        function updateList() {
            if (updateList.currentPromise === undefined) {
                updateList.currentPromise = null;
            }
            vm.loadingGrid = true;

            var getPromise = EmailAddressService.getAudits(emailAddressId, vm.currentPage, vm.listPageSize)
                .then(getEmailAddressAuditOk, getEmailAddressAuditError)
                .then(function () {
                    vm.loadingGrid = false;
                });

            updateList.currentPromise = getPromise;

            return getPromise;

            function getEmailAddressAuditOk(data) {
                if (getPromise === updateList.currentPromise) {
                    vm.error = null;
                    vm.emailAddressAudits = data.EmailAddressAudits;
                    vm.emailAddressAuditsCount = data.EmailAddressAuditsCount;
                } else {
                    return $q.reject();
                }
            }

            function getEmailAddressAuditError(response) {
                if (getPromise === updateList.currentPromise) {
                    vm.error = response;
                } else {
                    return $q.reject();
                }
            }
        }

        /**
         * Toggles the 'ShowDetails' property on the supplied email address audit.
         * If 'ShowDetails' is true the 'details' for the email address audit will be shown using an 'expando'.
         */
        function toggleAuditDetails(emailAddressAudit) {
            if (_.isNil(emailAddressAudit.ShowDetails) || !emailAddressAudit.ShowDetails) {
                emailAddressAudit.ShowDetails = true;
            } else {
                emailAddressAudit.ShowDetails = false;
            }
        }
        
        /**
         * Create/formats the 'audit type' for an email address audit using various properties.
         *
         * @returns {string} Returns the 'audit type' for supplied email address audit
         */
        function formatAuditType(emailAddressAudit) {
            var result = emailAddressAudit.AuditType;

            switch (emailAddressAudit.AuditType) {
                case 'Bounce':
                    result = emailAddressAudit.BounceType.substr(0, 1).toUpperCase() + emailAddressAudit.BounceType.substr(1) + ' ' + emailAddressAudit.AuditType;
                    break;
                case 'Complaint':
                    result = emailAddressAudit.ComplaintFeedbackType.substr(0, 1).toUpperCase() + emailAddressAudit.ComplaintFeedbackType.substr(1) + ' ' + emailAddressAudit.AuditType;
                    break;
            }

            return result;
        }

        /**
         * 'Close' the current view by navigating back to the previous page
         */
        function close() {
            NavigationAidService.goBack();
        }
    }
})();